export default function getCalendarsPopColors(wixStyles, calendarsList, dates) {
    var _a;
    var googleCalendarColors = ((_a = wixStyles === null || wixStyles === void 0 ? void 0 : wixStyles.numbers) === null || _a === void 0 ? void 0 : _a.siteOrGoogleCalendarColors) === 1;
    var eventsArr = Object.values(dates).flat();
    var res = [];
    calendarsList.map(function (item) {
        //@ts-ignore
        var element = eventsArr.find(function (el) { return el.calendarId === item.idCrypt; });
        if (typeof element !== 'undefined') {
            var calendarItem = {
                idCrypt: item.idCrypt,
                selected: item.selected,
                accessRole: item.accessRole,
                name: item.name,
                //@ts-ignore
                color: googleCalendarColors ? element.googleColor : element.eventColor,
            };
            //@ts-ignore
            res.push(calendarItem);
        }
    });
    return res;
}
//# sourceMappingURL=getCalendarsPopColors.js.map